export default {
    ACCOUNT_DETAILS_SUCCESS: 'account/details/success',
    ACCOUNT_DETAILS_FAILURE: 'account/details/failure',
    ACCOUNT_DETAILS_RESET: 'account/details/reset',
    ACCOUNT_USER_SUCCESS: 'account/user/success',
    ACCOUNT_USER_FAILURE: 'account/user/failure',
    REQUEST_START: 'general/request/in-progress',
    REQUEST_STOP: 'general/request/finished',
    // CONSTANTS FOR MESTORE
    UPDATE_LANGUAGE: 'UPDATE_LANGUAGE',
    GET_CUSTOMER_DETAILS_SUCCESS: 'GET_CUSTOMER_DETAILS_SUCCESS',
    REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
    GET_FEATURE_VERSION: 'GET_FEATURE_VERSION',
    GET_LANGUAGE_TRANSLATION: 'GET_LANGUAGE_TRANSLATION',
    GET_BOOT_SETTINGS: 'GET_BOOT_SETTINGS',
    USER_INFO_SUCCESS: 'USER_INFO_SUCCESS',
    ME_STATE_UPDATE: 'ME_STATE_UPDATE',
    USER_PERMISSIONS_SUCCESS: 'USER_PERMISSIONS_SUCCESS',
    USER_RESOURCE_RIGHT: 'USER_RESOURCE_RIGHT',
    CUSTOMER_INFO_SUCCESS: 'CUSTOMER_INFO_SUCCESS',
    SET_DEFAULT_CUSTOMER: 'SET_DEFAULT_CUSTOMER',
    SET_DEFAULT_CONTRACTS: 'SET_DEFAULT_CONTRACTS',
    SET_USER_TYPE: 'SET_USER_TYPE',
    XHR_CALL_INPROGRESS: 'XHR_CALL_INPROGRESS',
    XHR_CALL_END: 'XHR_CALL_END',
    ACCOUNT_DETAILS_ISINIT_UPDATE: 'ACCOUNT_DETAILS_ISINIT_UPDATE',
    ACCOUNT_DETAILS_ISCUSTOMERLOADED_UPDATE: 'ACCOUNT_DETAILS_ISCUSTOMERLOADED_UPDATE',
    ACCOUNT_CUSTOMER_DETAILS_SUCCESS: 'ACCOUNT_CUSTOMER_DETAILS_SUCCESS',
    ACCOUNT_USER_SETTINGS: 'ACCOUNT_USER_SETTINGS',
    SET_DISTRIBUTOR_VALUE: 'SET_DISTRIBUTOR_VALUE',
    UPDATE_MODAL_POPUP_STATUS: 'UPDATE_MODAL_POPUP_STATUS',
    UPDATE_MODAL_POPUP_CLOSE: 'UPDATE_MODAL_POPUP_CLOSE',
    USER_WISHLIST_ID_NAME: 'USER_WISHLIST_ID_NAME',
    USER_WISHLIST_ENTRIES: 'USER_WISHLIST_ENTRIES',
    USER_WISHLIST_COUNT: 'USER_WISHLIST_COUNT',
    USER_NOTIFICATION_INIT: 'USER_NOTIFICATION_INIT',
    USER_NOTIFICATION_COUNT: 'USER_NOTIFICATION_COUNT',
    WEB_SOCKET_CONNECTED: 'WEB_SOCKET_CONNECTED',
    WEB_SOCKET_RECONNECTING: 'WEB_SOCKET_RECONNECTING',
    WEB_SOCKET_LATEST_NOTIFICATION: 'WEB_SOCKET_LATEST_NOTIFICATION',
    WEB_SOCKET_LATEST_NOTIFICATION_SHOW: 'WEB_SOCKET_LATEST_NOTIFICATION_SHOW',
    APPLICATION_THEME: 'APPLICATION_THEME',
    CHECKOUT_ITEMS_LIST: 'CHECKOUT_ITEMS_LIST',
    GET_SCREEN_OVERLAY: 'GET_SCREEN_OVERLAY',
    ACCOUNT_USER_DETAILS_UPDATE: 'ACCOUNT_USER_DETAILS_UPDATE',
    NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
    PENDINGAPPROVAL: 'PENDINGAPPROVAL',
    SELFCHECKOUT: 'SelfCheckout',
    PO_PENDING: 'PO PENDING',
    PORTAL_TILES: 'PORTAL_TILES',
    TABLET_WIDTH: 768,
    DESKTOP_WIDTH: 1024,
    FORM_CONFIG_HIDE_DOWNLOAD: 'FORM_CONFIG_HIDE_DOWNLOAD',
    FEATURE_CONFIGURATION: 'FEATURE_CONFIGURATION',
    UPDATE_HYPHENIZED_CULTURE: 'UPDATE_HYPHENIZED_CULTURE',
    ON_PAGE_LOAD: 'onPageLoad',
    PORTAL: 'portal',
    GCDMS: 'GCDMS',
    DEFAULT_THEME: 'electric',
    SET_SUPPORTED_SUPPLIERS: 'SET_SUPPORTED_SUPPLIERS',
    SHOW_SPINNER: 'SHOW_SPINNER',
    INCREMENT_LOADING_ELEMENTS: 'INCREMENT_LOADING_ELEMENTS',
    DECREMENT_LOADING_ELEMENTS: 'DECREMENT_LOADING_ELEMENTS',
    NEW_AUTHENTICATOR: 'NEW_AUTHENTICATOR',
    SET_LANGUAGE: 'SET_LANGUAGE',
    SET_SUBMISSION_DETAILS: 'SET_SUBMISSION_DETAILS',
    // login State
};
export const BYTES_IN_MB = 1024 * 1024;
